import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginModel } from 'src/app/models/legacy';
import { AuthService } from 'src/app/services/auth.service';
import { ToastService } from 'src/app/shared-new/services/toast.service';
import { changePasswordValidator } from 'src/app/shared/validators/change-password-validator';

@Component({
  selector: 'app-change-password-popup',
  templateUrl: './change-password-popup.component.html',
  styleUrls: ['./change-password-popup.component.scss'],
})
export class ChangePasswordPopupComponent implements OnInit {
  @Input() public data: any;
  @Input() public user: LoginModel;
  public changePasswordForm: FormGroup;
  public isLoader = false;
  public responseErrors: any;

  public constructor(
    private readonly formBuilder: FormBuilder,
    public readonly modal: NgbActiveModal,
    private readonly authService: AuthService,
    private toastService: ToastService
  ) {
    this.authService.getUserData().subscribe((data) => {
      this.user = JSON.parse(data);
    });
  }

  public formSubmit(formData: { newPassword: any }): void {
    if (formData && this.user) {
      this.responseErrors = null;
      this.isLoader = true;
      
      this.authService.changePassword(formData).subscribe(
        (response) => {
          this.authService.login(this.user.username, formData.newPassword).subscribe((loginResponse) => {
            if (loginResponse.accessToken) {
              this.toastService.success(
                'Password has been updated successfully'
              );
              this.modal.close(JSON.stringify(this.data));
            }
            this.isLoader = false;
          });
        },
        (errorResponse: Error) => {
          this.isLoader = false;
          const errorData = JSON.parse(JSON.stringify(errorResponse));
          if (errorData?.error) {
            if (
              errorData?.status === 400 ||
              errorData?.status === 401 ||
              errorData?.status === 403
            ) {
              this.responseErrors = errorData?.error;
            }
          }
        }
      );
    }
  }

  closePopup(): void {
    this.modal.close(JSON.stringify(this.data));
  }

  public ngOnInit(): void {
    this.changePasswordForm = this.formBuilder.group({
      oldPassword: ['', [Validators.required]],
      newPassword: ['', Validators.required],
      confirmPassword: ['', [Validators.required, changePasswordValidator]],
    });
  }
}
